/* global toastr:false, moment:false */
(function() {
    'use strict';
    const production = true;
    angular
        .module('app.core')
        .constant('moment', moment)
        .constant('toastr', toastr)
        .constant('signaturePad', signaturePad)
        .constant('inscripcionVersion', 62)
        .constant('pagosOnlineEnable', true)
        .constant('apiSettings', {
            apiBaseUrl: production ? 'https://www.racers506.com/CrossCostaRica_WebApi/' : 'http://localhost/ITGInscripciones_RestAPI/',
            apiGometaBaseUrl: 'https://apis.gometa.org/'
        });
})();